/**
 * Decoration API Clients
 * Lookup data for HtmlCard, ContentDecoration, StylingDecoration.
 * Follows the same pattern as category.client.ts.
 */

import { BaseHttpClient } from './http.client';
import { atlasApiConfig } from './config';
import type { ApiResponse, HtmlCard, ContentDecoration, StylingDecoration } from '@atlas-forms/types-js';

const EP = {
  HTML_CARDS:            '/api/v1/shared/htmlcard/list',
  CONTENT_DECORATIONS:   '/api/v1/shared/contentdecoration/list',
  STYLING_DECORATIONS:   '/api/v1/shared/stylingdecoration/list',
} as const;

export class HtmlCardApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async listHtmlCards(request: Record<string, unknown> = {}): Promise<ApiResponse<HtmlCard[]>> {
    return this.postQuery<HtmlCard[]>(EP.HTML_CARDS, request);
  }
}

export class ContentDecorationApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async listContentDecorations(request: Record<string, unknown> = {}): Promise<ApiResponse<ContentDecoration[]>> {
    return this.postQuery<ContentDecoration[]>(EP.CONTENT_DECORATIONS, request);
  }
}

export class StylingDecorationApiClient extends BaseHttpClient {
  constructor(config?: { baseUrl?: string; timeout?: number }) {
    super({
      baseUrl: config?.baseUrl ?? atlasApiConfig.baseUrl,
      timeout: config?.timeout ?? atlasApiConfig.timeout,
    });
  }

  async listStylingDecorations(request: Record<string, unknown> = {}): Promise<ApiResponse<StylingDecoration[]>> {
    return this.postQuery<StylingDecoration[]>(EP.STYLING_DECORATIONS, request);
  }
}

export const htmlCardApiClient = new HtmlCardApiClient();
export const contentDecorationApiClient = new ContentDecorationApiClient();
export const stylingDecorationApiClient = new StylingDecorationApiClient();
